// FILE: src/components/NextSessionCard.js
//
// Always-visible Start Now CTA in the coach rail. Same activity data as
// NextUpCard in the primary column — duplicated visually so the CTA stays
// in reach as the learner scrolls.

import React from 'react';
import styles from './NextSessionCard.module.css';

export default function NextSessionCard({ activity, onStartSession }) {
  const title = activity?.description?.split(' — ')[0]
    || ((activity?.activity_type || 'Practice').replace(/_/g, ' '));
  const meta = activity ? formatMeta(activity) : 'Continue your prep';

  return (
    <div className={styles.card} data-testid="dashboard-rail-next-session">
      <div className={styles.label}>📅 Next Session</div>
      <div className={styles.title}>{capitalize(title)}</div>
      <div className={styles.meta}>{meta}</div>
      <button
        type="button"
        className={styles.btn}
        onClick={onStartSession}
        data-testid="dashboard-rail-start"
      >Start Now</button>
    </div>
  );
}

function capitalize(s) {
  if (!s) return s;
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function formatMeta(a) {
  const bits = [];
  if (typeof a.recommended_count === 'number') bits.push(`${a.recommended_count} questions`);
  if (typeof a.target_minutes === 'number')    bits.push(`~${a.target_minutes} min`);
  return bits.join(' • ') || 'Pick up where you left off';
}
